import React, { useEffect, useState } from 'react';

import ListItem from './CustomerListItem';
import VirtualScrollbar from '../../shared/VirtualScrollbar';
import { useAppSelector } from '../../../hooks/customHooks';
import { SWrapper } from '../styles/CustomerList.styled';
import { ICustomerDto } from '../../../api/client';
import { useKeyPress } from '@/common/useKeypress';
import { setActiveCustomer } from '@/features/customersSlice';
import { useAppDispatch } from '../../../hooks/customHooks';

interface IProps {
  filterValue: string;
}

const CustomerList: React.FC<IProps> = ({ filterValue }) => {
  const customers = useAppSelector((state) => state.customers.customers);
  const [filteredCustomers, setFilteredCustomers] = useState(customers.customers);
  const isEnterPressed = useKeyPress('Enter');
  const isNumpadEnterPressed = useKeyPress('NumpadEnter');
  const dispatch = useAppDispatch();

  if (!customers) {
    return null;
  }

  useEffect(() => {
    if ((isEnterPressed || isNumpadEnterPressed) && filteredCustomers.length) {
      dispatch(setActiveCustomer({ customer: filteredCustomers[0], docTypeIdInUrl: undefined }));
    }
  }, [isEnterPressed, isNumpadEnterPressed]);

  useEffect(() => {
    setFilteredCustomers(
      customers.customers.filter((customer) => {
        const criteria = filterValue.toLowerCase();
        const sysPrin = customer.sysPrin.system + customer.sysPrin.principle;
        const sysPrinWithHyphen = customer.sysPrin.sysPrin;
        const name = customer.name.toLowerCase();
        return sysPrin.startsWith(criteria) || sysPrinWithHyphen.startsWith(criteria) || name.startsWith(criteria);
      }),
    );
  }, [filterValue]);

  const SETTINGS = {
    itemHeight: 71.25,
    amount: 7,
    tolerance: 2,
    minIndex: 0,
    maxIndex: filteredCustomers.length - 1,
    startIndex: 0,
    hasFilter: filterValue.length > 0 ? true : false,
  };

  const getData = (index: number, bufferedItems: number) => {
    const data = [];
    const start = Math.max(SETTINGS.minIndex, index);
    const end = Math.min(index + bufferedItems - 1, SETTINGS.maxIndex);
    if (start <= end) {
      for (let i = start; i <= end; i++) {
        data.push(filteredCustomers[i]);
      }
    }
    return data;
  };

  return (
    <SWrapper>
      <VirtualScrollbar
        settings={SETTINGS}
        get={getData}
        row={(customer: ICustomerDto) => <ListItem key={customer.sysPrin.sysPrin} customer={customer}></ListItem>}
        height={370}
      ></VirtualScrollbar>
    </SWrapper>
  );
};

export default CustomerList;
